import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import AppTheme from '../../shared-theme/AppTheme';
import AppAppBar from './AppAppBar';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/system';
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase"; 
import { useAuth } from "../../context/AuthContext"; 
import { useEffect, useState } from "react";
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import { signOut } from "firebase/auth";
import { auth } from "../../firebase"; 
import { useNavigate } from "react-router-dom";

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  backdropFilter: 'blur(24px)',
  border: '1px solid',
  borderColor: (theme.vars || theme).palette.divider,
  backgroundColor: theme.vars
    ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
    : alpha(theme.palette.background.default, 0.4),
  boxShadow: (theme.vars || theme).shadows[1],
  padding: '8px 12px',
}));

const logoStyle = {
  width: '64px',
  opacity: 0.3,
};

export default function AdminStart(props) {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  // custom
  const { currentUser } = useAuth(); // or use auth.currentUser directly
  const [events, setEvents] = useState([]);
  const [invitedEvents, setInvitedEvents] = useState([]);

  const displayName = currentUser.displayName || "User";
  const email = currentUser.email;
  const photo = currentUser.photoURL || `https://ui-avatars.com/api/?name=${displayName}`;
    
  useEffect(() => {
      const fetchEvents = async () => {
        try {
          const q = query(
            collection(db, "events"),
            where("eventOwnerEmail", "==", currentUser.email)
          );
  
          const querySnapshot = await getDocs(q);
  
          const fetchedEvents = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
  
          setEvents(fetchedEvents);
        } catch (error) {
          console.error("Error fetching events:", error.message);
        }
      };
  
      if (currentUser?.email) {
        fetchEvents();
      }
  
      const fetchInvitedEvents = async () => {
        try {
          const eventsSnapshot = await getDocs(collection(db, "events"));
          const matchingEvents = [];
  
          for (const eventDoc of eventsSnapshot.docs) {
            const guestsRef = collection(db, "events", eventDoc.id, "guests");
            const guestsSnapshot = await getDocs(guestsRef);
  
            const isUserAGuest = guestsSnapshot.docs.some(
              guest => guest.data().guestEmail === currentUser.email
            );
  
            if (isUserAGuest) {
              matchingEvents.push({
                id: eventDoc.id,
                ...eventDoc.data()
              });
            }
          }
  
          setInvitedEvents(matchingEvents);
        } catch (error) {
          console.error("Error fetching invited events:", error);
        }
      };
      if (currentUser?.email) {
        fetchInvitedEvents();
      }  
  },[currentUser]);
  
  const navigate = useNavigate();
    
  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log("Logged out");
      // Optionally redirect to login
      navigate("/");
    } catch (error) {
          console.error("Logout failed:", error.message);
      }
  };
  // end of custom
  
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      {/* App bar */}
      <AppAppBar/>
      
      <div>  
         <Container
              id="testimonials"
              sx={{
                pt: { xs: 4, sm: 12 },
                pb: { xs: 8, sm: 16 },
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: { xs: 3, sm: 6 },
              }}
            >
              <Box
                sx={{
                  width: { sm: '100%', md: '60%' },
                  textAlign: { sm: 'left', md: 'center' },
                }}
              >
                <Stack
                        direction="row"
                        sx={{
                          p: 2,
                          gap: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          // borderTop: '1px solid',
                          // borderColor: 'divider',
                        }}
                      >
                        {/* <Avatar
                          sizes="small"
                          alt={email}
                          src={photo}
                          sx={{ width: 64, height: 64 }}
                        /> */}
                        {/* <Box>
                          <Typography variant="h5" gutterBottom sx={{ color: 'text.primary' , fontWeight: 500, lineHeight: '16px' }}>
                          Hi, {displayName}
                          </Typography>
                          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                            {email}
                          </Typography>
                        </Box> */}
                      </Stack>
                
                {/* <Typography
                  component="h2"
                  variant="h4"
                  gutterBottom
                  sx={{ color: 'text.primary' }}
                >
                  Testimonials
                </Typography> */}
                {/* <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                  What are you up to?
                </Typography> */}
                
              </Box>
              <Grid container spacing={2}>
                {/* Create a new event */}
                <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: 'flex' }}>
                    <Card
                      variant="outlined"                      
                      // sx={(theme) => ({
                      //   display: 'flex',
                      //   flexDirection: 'column',
                      //   justifyContent: 'space-between',
                      //   flexGrow: 1,
                      //   width: '100%',
                      //   backgroundRepeat: 'no-repeat',
                      //   backgroundImage:
                      //     'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
                      //   ...theme.applyStyles('dark', {
                      //     backgroundImage:
                      //       'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
                      //   }),
                      // })}
                      onClick={() => navigate(`/admin/create`)}
                    >
                      <CardContent>
                        <Typography
                          component="h2"
                          variant="h4"
                          gutterBottom
                          sx={{ color: 'text.primary' }}
                        >
                          Create
                        </Typography>
                        <Typography
                          variant="body1"                          
                          gutterBottom
                          sx={{ color: 'text.secondary' }}
                        >
                          Create a new event, invite friends to a friendly and interactive space.You can make some money by selling tickets.
                        </Typography>
                      </CardContent>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }}
                      >                        
                      </Box>
                    </Card>
                  </Grid>

                {events.map(event => (                                 
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} key={event.id} sx={{ display: 'flex' }}>
                    <Card
                      variant="outlined"                      
                      sx={(theme) => ({
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        flexGrow: 1,
                        width: '100%',
                        // backgroundRepeat: 'no-repeat',
                        // backgroundImage:
                        //   'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
                        // ...theme.applyStyles('dark', {
                        //   backgroundImage:
                        //     'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
                        // }),
                      })}
                      onClick={() => navigate(`/admin/${event.eventCode}`)}
                    >

                      <CardContent>
                        <Typography
                          component="h6"
                          variant="h6"
                          gutterBottom
                          sx={{ color: 'text.secondary' }}
                        >
                          {event.eventName}
                        </Typography>
                        <Typography
                          variant="body1"
                          gutterBottom
                          sx={{ color: 'text.secondary' }}
                        >
                          {event.eventDescription}
                        </Typography>
                      </CardContent>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }}
                      >
                        <CardHeader
                          avatar={<Avatar alt={event.eventOwnerName} src="/static/images/avatar/1.jpg" />}
                          title={event.eventOwnerName}
                          subheader={event.eventLocation}
                        />
                        {/* <img
                          src={event.eventImageURL}
                          alt={event.eventName}
                          style={logoStyle}
                        /> */}
                      </Box>
                    </Card>
                  </Grid>                  
                ))}                                
              </Grid>
          </Container>
      </div>
    </AppTheme>
  );
}
